import { createAsyncThunk } from '@reduxjs/toolkit'
import ProcessedSocialMediaAccount from './processed-social-media-account-model'
import {
  delete_processedSocialMediaAccount,
  load_processedSocialMediaAccounts,
  store_processedSocialMediaAccount,
} from './processedSocialMediaAccount-service'

export const LoadProcessedSocialMediaAccountsAsync = createAsyncThunk<any, any>(
  'composer/load/processedSocialMediaAccount',
  async (params: { uid: string }) => {
    return await load_processedSocialMediaAccounts(params)
  },
)

export const CreateProcessedSocialMediaAccountAsync = createAsyncThunk<
  any,
  any
>(
  'composer/create/processedSocialMediaAccount',
  async (params: ProcessedSocialMediaAccount) => {
    return await store_processedSocialMediaAccount(params)
  },
)

export const DeleteProcessedSocialMediaAccountAsync = createAsyncThunk<
  any,
  any
>('composer/delete/processedSocialMediaAccount', async (params) => {
  return await delete_processedSocialMediaAccount(params)
})
